import React from "react";
import { Button } from "../button/Button";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { ChangeDefaultCardModal } from "../changeDefaultCardModal/ChangeDefaultCardModal";
import { OverlayLoadingIndicator } from "../overlayLoadingIndicator/OverlayLoadingIndicator";
import { AuthorizeNetBottomSheet } from "../authorizeNetBottomSheet/AuthorizeNetBottomSheet";

type props = {};

export const PaymentCardButtons: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        width: "100%",
      }}>
      {paymentStore.paymentCards.length > 1 ? (
        <Button
          onPress={() => {
            paymentStore.isChangePaymentMethodModalVisible = true;
          }}
          text="Change Card"
          btnStyle={{
            flex: 1,
            height: 48,
            border: `2px solid ${Colors.darkBrown}`,
          }}
          textStyle={{ fontSize: 15 }}
        />
      ) : null}
      <div style={{ flex: 1 }}>
        <Button
          onPress={() => {
            paymentStore.setIsAddCardSheetVisible(true);
          }}
          text="Add Card"
          btnStyle={{
            width: "100%",
            height: 48,
            backgroundColor: Colors.darkBrown,
          }}
          textStyle={{ fontSize: 15, color: Colors.white }}
        />
      </div>
      <ChangeDefaultCardModal
        visible={paymentStore.isChangePaymentMethodModalVisible}
      />
      <AuthorizeNetBottomSheet
        isVisible={paymentStore.isAddCardSheetVisible}
        onClose={() => {
          paymentStore.setIsAddCardSheetVisible(false);
        }}
      />
      <OverlayLoadingIndicator
        loading={paymentStore.isPaymentCardLoading}
        text={
          paymentStore.isChangePaymentMethodModalVisible
            ? "Changing default payment method"
            : "Adding new card, please wait..."
        }
      />
    </div>
  );
});
